import React from 'react';

import visa from '../../svg/visa.svg';
import visaActive from '../../svg/visa-active.svg';
import amex from '../../svg/amex.svg';
import amexActive from '../../svg/amex-active.svg';
import bank from '../../svg/bank.svg';
import bankActive from '../../svg/bank-active.svg';
import './Billing.css';

interface Props {
  default: boolean;
  item: any;
  setDefault: any;
  remove: any;
}

function PaymentMethodItem(props: Props) {
  const name = props.item.object === 'card' ? props.item.brand : 'Bank';
  const mapper: { [ind: string]: any } = {
    Visa: (
      <img
        alt="Visa"
        src={props.default ? visaActive : visa}
        style={{ display: 'block', margin: '13px auto', maxWidth: 'initial' }}
      />
    ),
    'American Express': (
      <img
        alt="Amex"
        src={props.default ? amexActive : amex}
        style={{ display: 'block', margin: '13px auto', maxWidth: 'initial' }}
      />
    ),
    Bank: (
      <img
        alt="Bank account"
        src={props.default ? bankActive : bank}
        style={{ display: 'block', margin: '13px auto', maxWidth: 'initial' }}
      />
    ),
  };

  return (
    <div className="paymentItem method-row">
      <div
        className="cardBorder"
        style={{
          display: 'flex',
          flexWrap: 'nowrap',
          borderTop: props.default ? 'solid 2px #dddddd' : '0',
          marginBottom: props.default ? '20px' : '',
        }}
      >
        <div
          className={`paymentIcon ${props.default ? 'paymentIconDefault' : ''}`}
          onClick={() => props.setDefault(props.item.id)}
        >
          {mapper[name]}
        </div>
        <div
          className={`paymentItemName ${props.default ? 'paymentItemNameDefault' : ''}`}
          onClick={() => props.setDefault(props.item.id)}
          style={{ flexGrow: 1 }}
        >
          {name} Ending in {props.item.last4}
        </div>
        <div className={`paymentItemName ${props.default ? 'paymentItemNameDefault' : ''}`}>
          {props.default ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="11"
              viewBox="0 0 14 11"
              style={{ width: 'auto', height: 'auto' }}
              className="float-right"
            >
              <path
                fill="none"
                fillRule="evenodd"
                stroke="#FFF"
                strokeWidth="2"
                d="M1 5.5L4.5 9l8-8"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="10"
              height="10"
              viewBox="0 0 10 10"
              onClick={() => props.remove()}
              style={{ width: 'auto', height: 'auto' }}
              className="float-right"
            >
              <path
                fill="#999"
                fillRule="evenodd"
                d="M8.566.246L4.982 3.829 1.45.297A.833.833 0 1 0 .27 1.476l3.533 3.532L.246 8.566a.841.841 0 0 0 1.189 1.188l3.557-3.557L8.524 9.73a.834.834 0 1 0 1.18-1.18L6.171 5.018l3.583-3.584A.841.841 0 0 0 8.566.246z"
              />
            </svg>
          )}
        </div>
      </div>
    </div>
  );
}

export default PaymentMethodItem;
